import { useCallback } from 'react';
import { DragOverEvent } from '@dnd-kit/core';

import { ParticipantDto, Tournament } from '@features/shared/api/typings';
import {
  insertParticipantIntoTeamStart,
  moveParticipantInsteadOfAnother,
  moveParticipantToPreviousTeam,
} from '@features/tournament/ui/components/TournamentParticipantsEdit/components/participantsHelpers';

export function useOnDragOver(
  tournament: Tournament,
  onRearrangeParticipants?: (participants: ParticipantDto[]) => void,
  participants?: ParticipantDto[],
) {
  return useCallback(
    (dragEvent: DragOverEvent) => {
      const { active, over } = dragEvent;

      if (
        !participants ||
        !onRearrangeParticipants ||
        active.data.current?.type !== 'participant' ||
        !over
      )
        return;
      const userId = active.data.current.userId;
      const teamId = active.data.current.teamId;

      if (over.data.current?.type === 'team') {
        if (over.disabled) return;

        const targetTeamId = over.data.current.teamId;
        // При наведении на команду снизу - хотим попасть в команду выше.
        if (teamId === targetTeamId) {
          onRearrangeParticipants(
            moveParticipantToPreviousTeam(userId, participants!, tournament.teamModeSettings!.size),
          );
          return;
        }

        // При наведении на команду сверху - хотим попасть в команду
        onRearrangeParticipants(
          insertParticipantIntoTeamStart(
            userId,
            targetTeamId,
            participants!,
            tournament.teamModeSettings!.size,
          ),
        );
        return;
      }

      if (over.data.current?.type === 'participant') {
        const targetUserId = over.data.current.userId;
        if (userId === targetUserId || over.disabled) return;

        // Перетаскивание людей между собой
        onRearrangeParticipants(
          moveParticipantInsteadOfAnother(
            userId,
            over.data.current.userId,
            participants!,
            tournament.teamModeSettings!.size,
          ),
        );
        return;
      }
    },
    [tournament, participants, onRearrangeParticipants],
  );
}
